// extracted by mini-css-extract-plugin
export default {"botao_novo":"BotaoNovoAtualizado_botao_novo__ptzs7"};